import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { EsnEvaluationService } from './../../../../core/services/esn-evaluation/esn-evaluation.service';
import { Component, ViewChild } from '@angular/core';
import {
  NgSignaturePadOptions,
  SignaturePadComponent,
} from '@almothafar/angular-signature-pad';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  serverError,
  successSignature,
} from './../../../../core/models/messages';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Country } from 'country-state-city';
import { Subject, takeUntil } from 'rxjs';
import { ToastMessage } from './../../../../core/models/chapitreeval';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { translations } from '../../../../core/models/call-offer';
import { DatePipe } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-list-evaluation',
  templateUrl: './list-evaluation.component.html',
  styleUrls: ['./list-evaluation.component.css'],
})
export class ListEvaluationComponent {
  @ViewChild('signature', { static: true })
  signaturePad!: SignaturePadComponent;
  loadSpinner: boolean = false;
  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  pagination : boolean =false;

  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  skills: any = [];
  name: any = [];
  evaluationrecu:any
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  modalRef?: BsModalRef;
  file: any;
  fileError: string = '';
  fileExtention: string = '';
  sortAttr = '';
  listevaluation: any;
  urlimage: string = environment.baseUrlGaleryy;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  searchForm: FormGroup = this.createSearchForm();
  updateform!: FormGroup;
  skillsList: { name_FR: string }[] = [];
  currentSortColumn: string = 'name'; // Initial column to sort by
  private unsubscribeAll: Subject<void> = new Subject();
  signatureFile: any;
  formData = new FormData();
  seeMore: boolean = false;
  private signatureDataUrl: string | null = null;
  isCollapsed = true;
  // Créez un objet pour stocker les états des cases à cocher
  checkboxStates: { [key: string]: boolean } = {};
  check: any = [];
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  compt = [
    { id: 1, name: 'Immédiate' },
    { id: 2, name: '2 mois' },
    { id: 3, name: '3 mois' },
    { id: 4, name: '4 mois' },
    { id: 5, name: '5 mois' },
  ];
  contrat = [
    { id: 1, name: 'CDI' },
    { id: 2, name: 'CDD' },
    { id: 3, name: 'SIVP' },
    { id: 4, name: 'Freelance' },
    { id: 5, name: 'autres' },
  ];
  poste = [
    { id: 1, name: 'Hybrid' },
    { id: 2, name: 'à distance' },
    { id: 3, name: 'télétravail' },
  ];
  public signaturePadOptions: NgSignaturePadOptions = {
    minWidth: 1,
    canvasWidth: 300,
    canvasHeight: 250,
    backgroundColor: '#ffffff',
  };

  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  type = [
    { id: 1, name: 'Annuelle' },
    { id: 2, name: 'Suivi' },
    // { id: 3, name: 'Trimestre'},
  ];
  pv = [
    { id: 1, name: 'non remplie' },
    { id: 2, name: 'encours' },
    { id: 3, name: 'remplie' },
  ];
  idPv: any;

  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private ajoutcompterendu: EsnEvaluationService,
    private localStorageService: LocalStorageService,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig
  ) {}
  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.getListevaluationreceive();
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }

  sortData(item: string) {
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;

    this.getListevaluationreceive();
  }
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchevaluationreceive();
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchevaluationreceive();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListevaluationreceive();
      }
    }
  }
  getListevaluationreceive() {
    let dataPyload =
      this.sortAttr == ''
        ? {
            id: this.idclientConnected,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            ...{
              id: this.idclientConnected,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
  
    this.spinner.show();
    this.ajoutcompterendu.getListreceivedevaluation(dataPyload).subscribe({
      next: (response: any) => {
        this.evaluationrecu=response.data.data;
        // // Extract only the 'evaluation' part of the data
        // this.listevaluation = response.data.map((item: any) => item.evaluation);
  
        this.totalItems = response.data.total;
        this.spinner.hide();
        this.loadSpinnerTable = false;
      },
      error: (error: any) => {
        this.spinner.hide();
      },
    });
  }
  
  translateCountryName(name: string): string {
   
    return translations[name] || name;
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      consultant: ['', data?.consultant],
      state_pv: [null, data?.state_pv],
      evaluation_type: [null, data?.name],
      start_date: ['', data?.start_date],
      end_date: ['', data?.end_date],
    });
  }
  profilCompanyNavigation(id: any) {
    this.router.navigate(['/evaluation/details-eval-rec', { id: id }]);
  }
  /* search */
  searchevaluationreceive(pageNumber : number = this.currentPage) {
    let valueForm = this.searchForm.value;
    // let nameArray=valueForm?.first_name.split(' ')
    let search: string[] = [];
    search = [
      valueForm.start_date,
      valueForm.end_date,
      valueForm.evaluation_type,
      valueForm.consultant,
    ];
    let formattedEndDate = this.datePipe.transform(valueForm.end_date, 'yyyy-MM-dd');
    let formattedStartDate = this.datePipe.transform(valueForm.start_date, 'yyyy-MM-dd');
    let data = {
      consultant: valueForm.consultant,
      evaluation_type: valueForm.evaluation_type,
      state_pv: valueForm.state_pv,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      search: search,
      per_page: this.itemsPerPage,
      page: pageNumber,
    };

    this.spinner.show();
    this.ajoutcompterendu
      .searchreceivedevaluation(this.idclientConnected, data)
      .subscribe({
        next: (resSearch) => {
          if(this.startSearching == true) {
            this.currentPage = 1;
            this.startSearching = false;
          } 
          this.listevaluation = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
          this.spinner.hide();
        },
        error: (error) => {
          this.toastrService.error(serverError);
          this.spinner.hide();
        },
      });
  }

  /* filter */
  filterevaluationreceive(event: any) {
    // Mettez à jour l'état de la case à cocher dans l'objet
    this.checkboxStates[event.target.value] = event.target.checked;

    // Mettez à jour this.type en fonction des cases à cocher cochées
    this.check = Object.keys(this.checkboxStates).filter(
      (key) => this.checkboxStates[key]
    );
    this.getListevaluationreceive();
    if (this.check.length == 2) {
      this.check = [];
    }
    let data = {
      id: this.idclientConnected,
      dedicated_to: event.target.value,
      per_page: this.itemsPerPage,
      page: this.currentPage,
    };

    this.ajoutcompterendu.filterListreceivedevaluation(data).subscribe({
      next: (resSearch) => {
        this.listevaluation = resSearch;
        if (resSearch.status == 200) {
          this.listevaluation = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
        }
      },
      error: (error) => {
        this.toastrService.error(serverError);
      },
    });
  }
  formPV: FormGroup = this.createPVForm();

  createPVForm(data?: any) {
    return this.formBuilder.group({
      evaluation_send_id: [''],
      report: ['', data && data.report],
    });
  }
  toastMessages2: ToastMessage = {
    success: 'Ajout de votre compte rendu avec succès',
    error: 'Une compte  avec ce nom existe déjà',
  };
  evaluation_send_id!: string;
  createcompterendu() {
    if (this.formPV.invalid) {
      return;
    }
    this.formPV.get('evaluation_send_id')?.setValue(this.evaluation_send_id);
    this.spinner.show();
    this.ajoutcompterendu
      .ajoutercompterendu(this.formPV.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.toastrService.success(this.toastMessages2.success);
          this.closeModal();
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error?.message?.name) {
            this.toastrService.error(this.toastMessages2.error);
          } else {
            this.toastrService.error(serverError);
          }
        },
      });
  }

  closeModal() {
    this.modalRef?.hide();
    this.file = null;
    this.fileError = '';
    this.fileExtention = '';
  }
  drawComplete() {
    this.signatureDataUrl = this.signaturePad?.toDataURL();
    const blob = this.dataURLToBlob(this.signatureDataUrl);
    this.signatureFile = new File([blob], 'signature.png');
  }
  dataURLToBlob(dataURL: string): Blob {
    const arr = dataURL?.match(/:(.*?);/);
    if (arr && arr[1]) {
      const mime = arr[1];
      const bstr = atob(dataURL?.split(',')[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr?.charCodeAt(n);
      }

      return new Blob([u8arr], { type: mime });
    } else {
      return new Blob();
    }
  }
  drawStart(event: MouseEvent | Touch) {
    console.log('Start drawing', event);
  }
  clearSignature() {
    this.signaturePad?.clear();
  }

  sendSignature() {
    this.spinner.show();
    this.signatureDataUrl = this.signaturePad?.toDataURL();
    const blob = this.dataURLToBlob(this.signatureDataUrl);
    this.signatureFile = new File([blob], 'signature.png');

    if (!this.signatureFile) {
      this.spinner.hide();
      return;
    }

    this.formData.append('signature_file_candidate', this.signatureFile);
    this.ajoutcompterendu.addSignature(this.idPv, this.formData).subscribe(
      (response) => {
        this.toastrService.success(successSignature);
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        this.toastrService.error(serverError);
      }
    );
  }
}
